<template>
  <CCard>
    <CCardHeader>
      <!-- <CDropdown class="float-right" color=" p-0" placement="bottom-end">
        <template #toggler-content>
          <CIcon name="cil-settings" />
        </template>
        <CDropdownItem>Action</CDropdownItem>
        <CDropdownItem>Another action</CDropdownItem>
        <CDropdownItem>Something else here...</CDropdownItem>
        <CDropdownItem disabled>Disabled action</CDropdownItem>
      </CDropdown> -->
      <h4 class="card-title mb-0">{{ title }}</h4>
      <div class="small text-muted">{{ subtitle }}</div>
    </CCardHeader>
    <CCardBody>
      <CChartLine :datasets="datasets" :labels="labels" :options="options" />
    </CCardBody>
  </CCard>
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'

export default {
  name: 'WidgetLineChart',
  components: { CChartLine },
  props: {
    labels: {
      type: Array,
      default: function() {
        return []
      },
    },
    datasets: {
      type: Array,
      default: function() {
        return []
      },
    },
    title: { type: String, default: 'Grafiek!' },
    subtitle: { type: String, default: '' },
  },
  data() {
    return {
      options: {
        showLines: true,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                drawOnChartArea: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                maxTicksLimit: 5,
                // stepSize: Math.ceil(250 / 5),
                // max: 250,
              },
              gridLines: {
                display: true,
              },
            },
          ],
        },
      },
    }
  },
  computed: {
    defaultDatasets() {
      return [
        {
          label: 'Data One',
          backgroundColor: 'rgb(218, 32, 42, 0.9)',
          data: [30, 39, 10, 50, 30, 70, 35],
        },
        {
          label: 'Data Two',
          backgroundColor: 'rgb(41, 150, 198, 0.9)',
          data: [39, 80, 40, 35, 40, 20, 45],
        },
      ]
    },
  },
}
</script>
